<template>
  <el-tabs type="border-card"
    v-model="activeTabName"
    @tab-click="handleClickTab"
    @tab-remove="handleRemoveTab">
    <el-tab-pane
      v-for="item in allTabs"
      :key="item.name"
      :label="item.label"
      :name="item.name"
      :closable="item.closable">
      <component :is="item.component"></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import TabLoading from '@/components/common/TabLoading';
import TabLoadingError from '@/components/common/TabLoadingError';
import { menuMap } from '@/utils/menus';

const componentOptions = {
  loading: TabLoading,
  error: TabLoadingError,
  timeout: 30000,
};

export default {
  inject: ['reload'],
  components: {
    Home: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "homeView" */'@/views/ProjectHome/index'),
    }),
    Projects: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "projectView" */'@/views/Projects/index'),
    }),
    Project: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "projectView" */'@/views/Project/index'),
    }),
    ProjectEdit: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "projectView" */'@/views/ProjectEdit/index'),
    }),
    ProjectNew: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "projectView" */'@/views/ProjectNew/index'),
    }),
    AdmCollection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/AdmCollection/index'),
    }),
    SdmCollection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/SdmCollection/index'),
    }),
    SdmxCollection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/SdmxCollection/index'),
    }),
    SdmproCollection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/SdmproCollection/index'),
    }),
    Hda2Collection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/Hda2Collection/index'),
    }),
    Hda3Collection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/Hda3Collection/index'),
    }),
    Hda4Collection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/Hda4Collection/index'),
    }),

    Hda5Collection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/Hda5Collection/index'),
    }),
    Hda6Collection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/Hda6Collection/index'),
    }),
    Hda7Collection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/Hda7Collection/index'),
    }),
    Hda8Collection: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/Hda8Collection/index'),
    }),
    Detail: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/Detail/index'),
    }),
    UnionValue: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "collectionView" */'@/views/UnionValue/index'),
    }),
    AdmChart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/AdmChart/index'),
    }),
    SdmChart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/SdmChart/index'),
    }),
    SdmxChart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/SdmxChart/index'),
    }),
    SdmxRealTimeChart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/SdmxRealTimeChart/index'),
    }),
    SdmproTiltChart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/SdmproTiltChart/index'),
    }),
    SdmproVibrChart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/SdmproVibrChart/index'),
    }),
    Hda2Chart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/Hda2Chart/index'),
    }),
    Hda3Chart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/Hda3Chart/index'),
    }),
    Hda4Chart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/Hda4Chart/index'),
    }),
    Hda5Chart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/Hda5Chart/index'),
    }),
    Hda6Chart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/Hda6Chart/index'),
    }),
    Hda7Chart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/Hda7Chart/index'),
    }),
    Hda8Chart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "chartView" */'@/views/Hda8Chart/index'),
    }),
    Test: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "testView" */'@/views/Test/index'),
    }),
    AdminList: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "adminView" */'@/views/AdminList/index'),
    }),
    Setting: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "settingView" */'@/views/Setting/index'),
    }),
    InnerSetting: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "settingView" */'@/views/Setting/index2'),
    }),
    Coordinate: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "coordinateView" */'@/views/Coordinates/index'),
    }),
    Profile3d: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "profile3dView" */'@/views/Profile3d/index'),
    }),
    Profile: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "profileView" */'@/views/Profile/index'),
    }),
    State: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "stateView" */'@/views/State/index'),
    }),
    MoteState: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "stateView" */'@/views/MoteState/index'),
    }),
    Tunnel: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "tunnelView" */'@/views/Tunnel/index'),
    }),
    Branch: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "branchView" */'@/views/Branch/index'),
    }),
    Lab: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "labView" */'@/views/Lab/index'),
    }),
    AntiTwist: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "profileView" */'@/views/AntiTwist/index'),
    }),
    AntiJitter: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "profileView" */'@/views/AntiJitter/index'),
    }),
    AntiJitterList: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "profileView" */'@/views/AntiJitterList/index'),
    }),
    DataJump: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "dataJumpView" */'@/views/DataJump/index'),
    }),
    ClusterSetting: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "clusterView" */'@/views/ClusterSetting/index'),
    }),
    ClusterChart: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "clusterView" */'@/views/ClusterChart/index'),
    }),
    WarningManagement: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "homeView" */'@/views/WarningManagement/index'),
    }),
    MissingInsert: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "homeView" */'@/views/MissingInsert/index'),
    }),
    EquipmentHealth: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "homeView" */'@/views/EquipmentHealth/index'),
    }),
    PointInfo: () => ({
      ...componentOptions,
      component: import(/* webpackChunkName: "homeView" */'@/views/PointInfo/index'),
    }),
  },
  data() {
    return {
      allTabs: [
        {
          label: '首页',
          name: 'Home',
          component: 'Home',
          closable: false,
          keepOnchange: true,
          path: '/v2',
        },
      ],
      activeTabName: 'Home',
      currentCollection: '',
    };
  },
  computed: {
    currentProject() {
      return this.$store.state.project.currentProject;
    },
    devices() {
      return this.$store.state.device.devices;
    },
  },
  created() {
    this.$bus.$on('changeProject', () => {
      this.allTabs = this.allTabs.filter(t => t.keepOnchange);
      this.initTab();
    });
    this.$bus.$on('deleteProject', () => {
      this.allTabs = this.allTabs.filter(t => t.keepOnchange);
      this.initTab();
    });
    this.$bus.$on('closeTab', (tabName) => {
      this.handleRemoveTab(tabName);
    });
  },
  mounted() {
    this.initTab();
  },
  watch: {
    $route() {
      this.initTab();
    },
  },
  methods: {
    async initTab() {
      const route = this.$route;
      const deviceName = route.params.deviceId;
      const deviceSn = route.params.sn;
      const component = route.meta.componentName;
      const device = await this.$store.dispatch('device/findOrGetDevice', { deviceName });
      // tab.name标识tab唯一
      let name = device && Object.keys(device).length
        ? `${device.holeName || device.name}-${component}`
        : component;
      // tab.name标识tab唯一
      // const name = route.params.deviceId
      //   ? `${route.params.deviceId}-${component}`
      //   : component;
      if (deviceSn) {
        name = `${deviceSn}-${component}`;
      }

      const existTab = this.allTabs.find(tab => tab.name === name);
      if (!existTab) {
        // 设置标签label
        let label;
        if (device && (device.holeName || device.name)) {
          label = `${device.holeName || device.name} ${menuMap.get(route.name) || route.meta.title || route.name}`;
        } else if (deviceSn) {
          label = `${deviceSn} ${menuMap.get(route.name) || route.meta.title || route.name}`;
        } else {
          label = route.meta.title;
        }

        this.allTabs.push({
          label,
          name,
          component,
          closable: true,
          keepOnchange: route.meta.keepOnchange,
          path: route.path,
        });
      }
      this.activeTabName = name;
    },
    handleClickTab(targetTab) {
      const tabs = this.allTabs;
      const matchTab = tabs.find(tab => tab.name === targetTab.name);
      this.$router.push(matchTab.path);
    },
    handleRemoveTab(targetName) {
      const tabs = this.allTabs;
      let { activeTabName } = this;
      if (activeTabName === targetName) {
        const index = tabs.findIndex(tab => tab.name === targetName);
        const nextTab = tabs[index + 1] || tabs[index - 1];
        if (nextTab) {
          activeTabName = nextTab.name;
          this.$router.replace(nextTab.path);
        }
      }
      this.activeTabName = activeTabName;
      this.allTabs = tabs.filter(tab => tab.name !== targetName);
    },
  },
};
</script>

